export function removeCSSClass(ele: Element, cls: string): void {
    if (ele.classList.contains(cls)) {
        ele.classList.remove(cls);
    }
}

export function addCSSClass(ele: Element, cls: string): void {
    ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname: string): string => `${process.env.PUBLIC_URL || ''}${pathname}`;
